<mat-toolbar>

    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutAlign.gt-xs="space-between center" fxFlex>
        <div fxLayout="row" fxLayoutAlign="start center" fxHide fxShow.gt-xs>
            <span class="mat-body-1">Educational Testing Service - APMOD — Copyright®</span>
        </div>       
    </div>

</mat-toolbar>
